import { render, staticRenderFns } from "./StaffSelectionModal.vue?vue&type=template&id=00b3bfc1&scoped=true"
import script from "./StaffSelectionModal.vue?vue&type=script&lang=js"
export * from "./StaffSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./StaffSelectionModal.vue?vue&type=style&index=0&id=00b3bfc1&prod&scoped=true&lang=css"
import style1 from "./StaffSelectionModal.vue?vue&type=style&index=1&id=00b3bfc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3bfc1",
  null
  
)

export default component.exports